export default __webpack_public_path__ + "static/media/habrImg5.758f0d2d.jpeg";